import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { permissionConstants } from 'src/app/shared/services';

export type TokenClaim = {
  aud: string;
  iss: string;
  iat: number;
  nbf: number;
  exp: number;
  name: string;
  oid: string;
  preferred_username: string;
};

@Injectable({
  providedIn: 'root',
})
export class TokenClaimsService {
  tokenClaims$: TokenClaim;
  isEnergyCreditAdmin: boolean = false;
  canAccessEC: boolean = false;
  isAdmin: boolean = false;
  //QBuilt
  canAccessQBuilt: boolean = false;
  private _idToken: string = '';
  canAccessHomeOfficeAdmin: boolean = false;

  constructor(private msalService: MsalService) {}

  setTokenClaim(idTokenClaims: any): void {
    this.tokenClaims$ = idTokenClaims as TokenClaim;
  }

  setPermissions(tokenClaims: any): void {
    const roles: string[] = tokenClaims.roles || [];

    this.isAdmin = !!roles.find((x) => x === permissionConstants.siteAdmin);
    this.canAccessEC =
      this.isAdmin ||
      roles.some((x) => permissionConstants.energyCredits.includes(x));
    this.isEnergyCreditAdmin =
      this.isAdmin || roles.some((x) => x === 'EnergyCreditsAdmin');

    this.canAccessQBuilt = roles.some((x: string) =>
      permissionConstants.qBuilt.includes(x),
    );
    this.canAccessHomeOfficeAdmin = roles.find(
      (x: string) => x == permissionConstants.homeOfficeAdmin,
    )
      ? true
      : false;
  }

  hasRole(role: string): boolean {
    return (
      this.msalService.instance
        .getAllAccounts()[0]
        .idTokenClaims?.roles.indexOf(role) > -1
    );
  }

  setIdToken(token: string): void {
    this._idToken = token;
  }

  getIdToken(): string {
    this.setIdToken(this.msalService.instance.getAllAccounts()[0].idToken);
    return this._idToken;
  }
}
